import { createTheme } from '@mui/material/styles';

import { DA_KAUFLAND_THEME } from '../theme';
import colors from '../tokens/colors';
import { daKauflandFontFamily } from '../tokens/fonts';
import typography from '../tokens/typography/daKaufland';

import baseTheme from './base.theme';

// base component styles
import { accordionDaKaufland } from '../components/accordion.style';
import { autocompleteDaKaufland } from '../components/autocomplete.style';
import { buttonDaKaufland } from '../components/button.style';
import { checkboxDaKaufland } from '../components/checkbox.style';
import { emailDaKaufland } from '../components/email.style';
import { inputDaKaufland } from '../components/input.style';
import { linkDaKaufland } from '../components/link.style';
import { listDaKaufland } from '../components/list.style';
import { phoneDaKaufland } from '../components/phone.style';
import { radioDaKaufland } from '../components/radio.style';
import { selectDaKaufland } from '../components/select.style';
import { toggleSwitchDaKaufland } from '../components/toggleSwitch.style';

// widget styles
import { backButtonDaKaufland } from '../widgets/backButton.style';
import { daDirektCodeDaKaufland } from '../widgets/daDirektCode.style';
import { formLabelDaKaufland } from '../widgets/formLabel.style';
import { informationTextDaKaufland } from '../widgets/informationText.style';
import { pageHeaderDaKaufland } from '../widgets/pageHeader.style';
import { priceButtonDaKaufland } from '../widgets/priceButton.style';

const theme = createTheme(baseTheme, {
  name: DA_KAUFLAND_THEME,
  palette: {
    background: {
      primary: colors.DA_KAUFLAND_BLACK,
      accordion: {
        header: colors.DA_KAUFLAND_LIGHT_GRAY_2,
        body: colors.WHITE,
        footer: colors.DA_KAUFLAND_LIGHT_GRAY_2,
      },
      button: colors.DA_KAUFLAND_BLACK,
      input: colors.WHITE,
      modalOverlay: colors.DA_KAUFLAND_LIGHT_GRAY,
      pageHeaderTitle: 'transparent',
      selectOption: colors.WHITE,
    },
    text: {
      primary: colors.DA_KAUFLAND_BLACK,
      secondary: colors.DA_KAUFLAND_BLACK,
      accent: colors.DA_KAUFLAND_BLACK,
      button: colors.WHITE,
      checkbox: colors.DA_KAUFLAND_BLACK,
      input: colors.DA_KAUFLAND_BLACK,
      label: colors.DA_KAUFLAND_BLACK,
      placeholder: colors.DA_DIREKT_GRAY_3,
    },
    error: {
      main: colors.DA_KAUFLAND_RED,
    },
    success: {
      main: colors.DA_KAUFLAND_GREEN,
    },
  },
  shadows: [
    baseTheme.shadows[0],
    baseTheme.shadows[1],
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
  ],
  typography: {
    fontFamily: daKauflandFontFamily,
    ...typography,
  },
  components: {
    accordion: accordionDaKaufland,
    autocomplete: autocompleteDaKaufland,
    button: buttonDaKaufland,
    checkbox: checkboxDaKaufland,
    email: emailDaKaufland,
    input: inputDaKaufland,
    link: linkDaKaufland,
    list: listDaKaufland,
    phone: phoneDaKaufland,
    radio: radioDaKaufland,
    select: selectDaKaufland,
    toggleSwitch: toggleSwitchDaKaufland,
  },
  widgets: {
    backButton: backButtonDaKaufland,
    daDirektCode: daDirektCodeDaKaufland,
    formLabel: formLabelDaKaufland,
    informationText: informationTextDaKaufland,
    pageHeader: pageHeaderDaKaufland,
    priceButton: priceButtonDaKaufland,
  },
});

export default theme;
